/**
 * Where the invitation flow ends. It is never `/`, because activating an account creates no session:
 * the link token gives access to the flow, not to the application.
 */
export const SIGN_IN_ROUTE = '/signin';

/** Public route where the recovery flow starts: the address capture and the sent notice. */
export const PASSWORD_RECOVERY_ROUTE = '/auth/recover';

/** Public route the recovery link lands on after the consume, where the new password is written. */
export const PASSWORD_RESET_ROUTE = '/auth/recover/reset';

/** The private, full-screen route of the account verification wizard. */
export const VERIFY_ACCOUNT_ROUTE = '/verify-account';

/**
 * Where the verification flow ends. Reports is the landing of most accounts, and one that cannot see
 * it is sent on to the first module it does have, so naming it here costs nothing and lands the rest
 * on the page they expect. The root would be the neutral choice, but it resolves to the menus for
 * anyone who is not a super user.
 */
export const PORTAL_ENTRY_ROUTE = '/reports';

/** Mi perfil, inside the application frame. Any valid session enters: it asks for no permission. */
export const PROFILE_ROUTE = '/profile';

/** The wait for the link that verifies a phone changed from Mi perfil. Full screen, no frame. */
export const PROFILE_VERIFY_PHONE_ROUTE = '/profile/verify-phone';

/** The in-session password change. Full screen, no frame. */
export const PROFILE_CHANGE_PASSWORD_ROUTE = '/profile/change-password';

/** Clears the session and lands on the sign in. */
export const SIGN_OUT_ROUTE = '/signout';
